const SESSION_STORAGE_KEY = 'ole_app_session_id';

export function getOrCreateAppSessionId(storage = window.sessionStorage) {
  const existing = storage.getItem(SESSION_STORAGE_KEY);
  if (existing) return existing;
  const generated = window.crypto?.randomUUID
    ? window.crypto.randomUUID()
    : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
        const value = Math.random() * 16 | 0;
        const output = char === 'x' ? value : ((value & 0x3) | 0x8);
        return output.toString(16);
      });
  storage.setItem(SESSION_STORAGE_KEY, generated);
  return generated;
}

export function shouldRegisterAppSession(ref) {
  if (ref.current) return false;
  ref.current = true;
  return true;
}

export function getHeartbeatMs(value = process.env.REACT_APP_SESSION_HEARTBEAT_SECONDS) {
  const seconds = Math.max(parseInt(value, 10) || 60, 15);
  return seconds * 1000;
}

export function buildLaunchSource({ urlHubspotOrderId, urlDealId, urlOrderId, urlStoreId }) {
  if (urlHubspotOrderId || urlDealId) return 'hubspot';
  if (urlOrderId) return 'direct-order';
  if (urlStoreId) return 'store-bookmark';
  return 'order-editor';
}